import { render, staticRenderFns } from "./Payoneer.vue?vue&type=template&id=b664fa4e&scoped=true"
import script from "./Payoneer.vue?vue&type=script&lang=js"
export * from "./Payoneer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b664fa4e",
  null
  
)

export default component.exports